import { showToast } from "./toast";

export function handleApiError(
  error: any,
  fallbackMessage = "Ocorreu um erro. Tente novamente."
) {
  const errors = error?.response?.data?.errors;

  if (Array.isArray(errors) && errors.length > 0) {
    errors.forEach((item) =>
      showToast({
        type: "error",
        message: `${item?.code} - ${item?.description}`,
      })
    );
    return;
  }

  showToast({ type: "error", message: fallbackMessage });
}
